import { Ref, useState } from 'react';
import { Box, IconButton, TextField } from '@mui/material';
import { faPaperPlaneTop } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty, noop, trim } from 'lodash';
import classNames from 'classnames';

interface AddReplyProps {
  initialText?: string;
  submit?: (text: string) => void;
  inputRef?: Ref<HTMLInputElement>;
}

export const AddReply = ({
  initialText = '',
  submit = noop,
  inputRef = undefined,
}: AddReplyProps) => {
  const [text, setText] = useState(initialText);

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) =>
    setText(event.target?.value);

  return (
    <Box className="border-t flex pt-5">
      <TextField
        InputProps={{ className: 'rounded-[2rem]' }}
        inputRef={inputRef}
        variant="outlined"
        multiline
        className="w-full mr-2"
        placeholder="Message"
        onChange={handleChange}
        value={text}
      />
      <IconButton
        className={classNames([
          'bg-purple-1',
          'disabled:bg-gray-2',
          'mb-1',
          'text-white',
          'w-[50px]',
          'h-[50px]',
          'rounded-full',
          'self-end',
          { hidden: isEmpty(text) },
        ])}
        aria-label="Send the reply"
        disabled={isEmpty(trim(text))}
        onClick={() => submit(text)}
      >
        <FontAwesomeIcon size="2xs" icon={faPaperPlaneTop} />
      </IconButton>
    </Box>
  );
};
